export default __webpack_public_path__ + "static/13-f5f1bb138e0b177bc012f52155194c23.jpg";